import { observer } from "mobx-react";
import DownloadIcon from "@mui/icons-material/Download";
import EventIcon from "@mui/icons-material/Event";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import FilledButton from "../../../components/buttons/FilledButton";
import FormSection from "../../../forms/FormSection";
import FormRow from "../../../forms/FormRow";
import FormDateField from "../../../components/fields/FormDateField";
import ChartSkeleton from "../../dashboard/charts/ChartSkeleton";
import { useApplication } from "../../../ApplicationProvider";
import useFeature from "../../../useFeature";
import SoldBoxesByCustomerAndArticleFeature from "./SoldBoxesByCustomerAndArticleFeature";
import SoldBoxesByCustomerAndArticleTable from "./SoldBoxesByCustomerAndArticleTable";
import exportSoldBoxesByCustomerAndArticleToExcel from "./soldBoxesByCustomerAndArticleExcelExport";

function SoldBoxesByCustomerAndArticleScreen() {
    const application = useApplication();
    const feature = useFeature(() => new SoldBoxesByCustomerAndArticleFeature(application));
    const isFeatureReady = feature && feature.loaded;

    const table = () => (feature.tableLoaded
        ? (
            <SoldBoxesByCustomerAndArticleTable
                columns={feature.columns()}
                rows={feature.presentedRows()}
                onVisibleRowsChange={(visibleRows) => feature.setVisibleRows(visibleRows)}
                pageSize={100}
                pageSizeOptions={[25, 50, 100]}
                emphasizedRowPredicate={(row) => row.id === SoldBoxesByCustomerAndArticleFeature.TOTAL_ROW_ID}
                selectFilters={[
                    {
                        label: "Categoría",
                        options: feature.articleCategoryOptions(),
                        selectedValues: feature.selectedArticleCategories(),
                        onChange: (articleCategories) => feature.selectArticleCategories(articleCategories),
                    },
                ]}
                queryFilters={[
                    {
                        label: "Entrega mañana",
                        icon: <EventIcon/>,
                        isActive: feature.isShowingTomorrowDeliveryOnly(),
                        onToggle: () => feature.toggleTomorrowDeliveryOnly(),
                    },
                ]}
            />
        )
        : <ChartSkeleton/>);

    const content = () => (
        <div>
            <LayoutContentToolbar title="Cajas por Cliente y Artículo">
                <FilledButton
                    disabled={!feature.tableLoaded}
                    onClick={() => exportSoldBoxesByCustomerAndArticleToExcel(
                        feature.articleColumnNames(), feature.rowsForExport(), feature.totalForExport())}>
                    <DownloadIcon fontSize="small"/>
                    Exportar
                </FilledButton>
            </LayoutContentToolbar>

            <FormSection title="Filtros">
                <FormRow>
                    <FormDateField label="Desde" field={feature.fromDateField()} minDate={feature.minimumSelectableDate()}/>
                    <FormDateField label="Hasta" field={feature.toDateField()} minDate={feature.minimumSelectableDate()}/>
                </FormRow>
            </FormSection>

            {table()}
        </div>
    );

    return <LayoutContentWrapper isLoading={!isFeatureReady} renderContent={() => content()}/>;
}

export default observer(SoldBoxesByCustomerAndArticleScreen);
